/**
 * Gets locale from window.location .
 * E.g., if current url where code is run is www.hm.com/en-au/...,
 * function returns "en-au"
 *
 * For hw_il locale, it is converted to 'he_il' as that is the correct locale as per standards
 *
 * @return {?string} - Value of locale in current url or null if property not accessible.
 * Returns null if locale is missing from expected position in url.
 */
const getLocaleFromUrl = () => {
    var _a, _b;
    const localeRegex = /^([a-zA-Z]{2})[-_]([a-zA-Z]{2})$/;
    const locale = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.split('/')[1];
    const isLocale = localeRegex.test(locale);
    if (!isLocale)
        return null;
    if (locale === 'hw_il')
        return 'he_il';
    if (locale) {
        return locale;
    }
    return null;
};
export default getLocaleFromUrl;
//# sourceMappingURL=getLocaleFromUrl.js.map